import React from 'react';
import PropTypes from 'prop-types';
import {StyledVendorInvoices} from './StyledVendorInvoices';
import InvoiceSnippet from '../InvoiceSnippet';

const VendorInvoices = ({
  data = [],
  ...rest
}) => {
  return (
    <StyledVendorInvoices
      direction='vertical'
      size='middle'
      {...rest}
    >
      {data.map((item, key) => <InvoiceSnippet invoice={item} key={key} />)}
    </StyledVendorInvoices>
  );
}

VendorInvoices.propTypes = {
  data: PropTypes.array
}

export default VendorInvoices;
